// extracted by mini-css-extract-plugin
export var alertIcon = "_s8-0";